// src/pages/Questions.tsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { updateDecisionSurvey } from "../types/api";
import { useUser } from "../context/UserContext";
import { useLanguage } from "../context/LanguageContext";
import { labelsMap } from "../i18n/languageMap"; 

import "../style/question.css";

type Answer = "START_BUSINESS" | "ADVICE_BUSINESS";

const Questions: React.FC = () => {
  const [selectedAnswer, setSelectedAnswer] = useState<Answer>("START_BUSINESS");
  const navigate = useNavigate();
  const { user, setUser } = useUser();
  const { country, language } = useLanguage();

  // Pick correct labels, fallback to English
  const labels = labelsMap[language] || labelsMap["English"];
  //alert(language);
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedAnswer(event.target.value as Answer);
  };

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();

    if (!user?.mobile) {
      console.error("User mobile not available");
      return;
    }

    await updateDecisionSurvey(user.mobile, selectedAnswer);

    // Save decision in UserContext
    setUser({ ...user});
    //setUser({ ...user, decision: selectedAnswer });

    if (selectedAnswer === "START_BUSINESS") {
      navigate("/occupationSurvey");
    } else {
      navigate("/userDetailsForm");
    }
  };

  return (
    <div className="div-container">
      <h2>{labels.CurrentlyDoing}</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label className="radio-label">
            <input
              type="radio"
              value="START_BUSINESS"
              checked={selectedAnswer === "START_BUSINESS"}
              onChange={handleChange}
            />
            {labels.option1}
          </label>
        </div>
        <div>
          <label className="radio-label">
            <input
              type="radio"
              value="ADVICE_BUSINESS"
              checked={selectedAnswer === "ADVICE_BUSINESS"}
              onChange={handleChange}
            />
            {labels.option2}
          </label>
        </div>
        <button type="submit">{labels.submit}</button>
      </form>
    </div>
  );
};

export default Questions;
